exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\nsvg[data-v-583d8a06] {\n  height: 30px;\n  width: 30px;\n}\nsvg path[data-v-583d8a06] {\n    fill: #26D97A;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Partials/SVG/Wheelchair.vue"],"names":[],"mappings":";AACA;EACE,aAAa;EACb,YAAY;CACb;AACD;IACI,cAAc;CACjB","file":"Wheelchair.vue","sourcesContent":["\nsvg[data-v-583d8a06] {\n  height: 30px;\n  width: 30px;\n}\nsvg path[data-v-583d8a06] {\n    fill: #26D97A;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-583d8a06","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Partials/SVG/Wheelchair.vue
// module id = 1280
// module chunks = 0